import { CLEAR_BOOKING_LINK_TREATMENT_DETAILS, CLEAR_TREATMENT_DETAILS, GET_TREATMENT_DETAILS } from "../../constants/treatment-list-const/TreatmentListConst";


const initialState={
  treatementDetail:[]
}

export default function treatmentsDetailReducer(state = initialState, action) {

  switch (action.type) {

    case GET_TREATMENT_DETAILS:
      return {
        ...state,
        treatementDetail: action.payload,
    };
    case CLEAR_TREATMENT_DETAILS:
      return {
        ...state,
        treatementDetail: null,
    };
    case CLEAR_BOOKING_LINK_TREATMENT_DETAILS:
      return {
        ...state,
        treatementDetail: null,
    };

    default:
      return state;
  }



}